import { render, staticRenderFns } from "./changeIdentity.vue?vue&type=template&id=bd6560d2&scoped=true"
import script from "./changeIdentity.vue?vue&type=script&lang=js"
export * from "./changeIdentity.vue?vue&type=script&lang=js"
import style0 from "./changeIdentity.vue?vue&type=style&index=0&id=bd6560d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd6560d2",
  null
  
)

export default component.exports